import { useSelector } from 'react-redux';

import { isNewCarSelector } from '../../../../../../../store/selectors';
import { GearType, GearTypeKey, Upgrade } from '../../../../../../../types';
import {
	getCarFuelType,
	getInteriorColorAndFabric,
	getInteriorFabricFromEquipment,
} from '../../../../../../../utils';
import { formatPowerInKilowatt } from '../../../../../../../utils/vehicle';

type Props = {
	selectedVehicle: Upgrade;
};

export const UpgradeDescriptionListItems = ({ selectedVehicle }: Props) => {
	const { fuelType, enginePowerKW, enginePowerHP, gearType, doors, standardEquipment, year } =
		selectedVehicle.vehicleData;
	const interior = getInteriorFabricFromEquipment(standardEquipment);
	const isNewCar = useSelector(isNewCarSelector);

	return [
		{
			key: 'Brandstof',
			value: getCarFuelType(fuelType),
		},
		{
			key: 'Transmissie',
			value: GearType[gearType as GearTypeKey],
		},
		{
			key: 'Vermogen',
			value: formatPowerInKilowatt(Number(enginePowerKW), {
				horsePower: Number(enginePowerHP),
			}),
		},
		...(!isNewCar ? [{ key: 'Bouwjaar', value: year }] : []),
		{
			key: 'Aantal deuren',
			value: doors,
		},
		{
			key: 'Bekleding',
			value: getInteriorColorAndFabric(interior, ''),
		},
	];
};
